var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropdownArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 6,
    height: 5,
    viewBox: "0 0 6 5",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.61593 0.330188C3.34218 -0.110063 2.65782 -0.110062 2.38407 0.330189L0.0963454 4.00943C-0.1774 4.44969 0.164782 5 0.712273 5L3 4.0566L5.28773 5C5.83522 5 6.1774 4.44969 5.90365 4.00943L3.61593 0.330188Z",
    fill: "#7E8CA8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownArrow);
export default __webpack_public_path__ + "static/media/dropdownArrow.f3b2ac9f0e5e9632029719e42c9fb400.svg";
export { ForwardRef as ReactComponent };